import * as React from "react";
// import { Button } from "antd";
import ExportExcelProcess from "widget/exportExcel";

import { connect } from "react-redux";

import { filterParams } from "utils/tool";

import { message } from "antd";

interface IExportExcelProps {
  // 表单参数
  formParam: any;
  // 导出Excel方法
  exportOrder: any;
}

class ExportExcel extends React.Component<IExportExcelProps, any> {
  state = {
    visible: false
  };

  constructor(props: IExportExcelProps) {
    super(props);
  }

  showProcess = () => {
    this.setState({
      visible: true
    });
  };

  export = () => {
    let param: any = filterParams(this.props.formParam);
    delete param.queryHistory;
    delete param.type;
    if (Object.keys(param || {}).length === 0) {
      message.warning("无筛选条件，不允许导出表格");
      return false;
    } else {
      param.queryHistory = this.props.formParam.queryHistory;
      param.type = this.props.formParam.type;
    }
    let isTruly = true;
    this.props.exportOrder({
      ...this.props.formParam,
      callback: res => {}
    });
    return isTruly;
  };

  render() {
    return (
      <div className="button-group-child">
        <ExportExcelProcess exportHandle={this.export} />
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    exportOrder: dispatch.orderInfo.exportOrder
  };
};

export default connect(
  null,
  mapDispatch
)(ExportExcel);
